import { Link } from 'react-router-dom';
import { categories } from '@/pages/home/data/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="inline-flex items-center gap-2 font-heading text-lg font-bold text-background-50 mb-4 whitespace-nowrap">
                <span className="w-7 h-7 flex items-center justify-center bg-primary-500 text-background-50 rounded-md text-xs font-bold">
                  P
                </span>
                pandabuy<span className="text-primary-400">.team</span>
              </Link>
              <p className="text-sm text-background-300 leading-relaxed">
                Your trusted source for curated pandabuyspreadsheet finds. Discover trending products, compare prices and shop smarter with our daily updated spreadsheets.
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                Quick Links
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/pandabuy-spreadsheet-guide" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    pandabuyspreadsheet Guide
                  </Link>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    pandabuy sheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Buy It Now
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                Top Categories
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                More Categories
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(6).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2026 pandabuy.team — All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="/" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Privacy Policy</a>
              <a href="/" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}